export default function CacheService() {
  'ngInject'

  function saveId(name, id) {
    localStorage.setItem(name, id)
  }

  function getId(name) {
    return localStorage.getItem(name)
  }

  function urls(name, data, clean) {
    if (clean) {
      localStorage.removeItem('Sets')
      localStorage.removeItem('Collectibles')
      localStorage.removeItem('Bundles')
    } else {
      localStorage.setItem(name, data)
    }
  }

  return {
    saveId: saveId,
    getId: getId,
    urls: urls,
  }
}
